import Box from '@mui/material/Box';
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Link, useMatch, useResolvedPath } from "react-router-dom"

export default function CSBlurb() {
    return (
        <>
            <Box>
                <Typography variant='h4' fontFamily='Proxima Nova' gutterBottom>
                    <b><Link to="/about" style={{ textDecoration: 'none', color: '#a60202' }}>Service</Link></b>
                </Typography>
                <Typography variant='body2' fontFamily='Proxima Nova' gutterBottom>
                    The brothers of Theta Tau strive not only to help each other socially and academically, but also to help the greater Boston community. Our Service pillar is very important to our brothers. Each new member class holds a community service event, which is a great way to not only give back but also have fun and bond. In addition, our fraternity as a whole holds events and collaborates with other organizations. 
                ​</Typography>
            </Box>
        </>
    );
  }